import { render, staticRenderFns } from "./LFPopUp.vue?vue&type=template&id=3b3f7920&"
import script from "./LFPopUp.vue?vue&type=script&lang=js&"
export * from "./LFPopUp.vue?vue&type=script&lang=js&"
import style0 from "./LFPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports